import Util from '../../util/funcoes';
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  data() {
    return {
      isLoading: false,
    };
  },

  created() {
    this.listar();
  },

  computed: {
    ...mapState('ultimosImoveisAluguelStore', {
      imoveis(state) { return state.listaImoveis }
    }),
    util() { return Util; }
  },

  methods: {
    ...mapMutations('ultimosImoveisAluguelStore', [
      'limparImoveis',
    ]),

    ...mapActions('ultimosImoveisAluguelStore', [
      'recuperarUltimosImoveisAluguel',
    ]),

    listar() {
      this.isLoading = true;
      this.limparImoveis();
      this.recuperarUltimosImoveisAluguel()
        .then()
        .finally(() => {
          this.isLoading = false;
        });
    },
  }
};